import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LogoService {
  private _logoUrl$ = new BehaviorSubject<string | null>(null);
  logoUrl$ = this._logoUrl$.asObservable();

  setLogo(url: string | null) {
    this._logoUrl$.next(url);
  }

  clearLogo() {
    this._logoUrl$.next(null);
  }
}
